module.exports = __webpack_public_path__ + "img/reports-sales.0afc7c3c.jpg";